import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'attributionGenerated'
	| 'attributionAnswer'
	| 'triggerLabel'
	| 'panelHeading'
	| 'closePanel'
	| 'viewExpert';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description: string }> =
	defineMessages({
		attributionGenerated: {
			id: 'rovo-platform-ui-components.authoritative-answer-attribution.attributionGenerated',
			defaultMessage: 'Verified across {trigger}',
			description:
				'Chat variant: attribution line shown above an AI answer. {trigger} is a clickable link reading "high confidence knowledge".',
		},
		attributionAnswer: {
			id: 'rovo-platform-ui-components.authoritative-answer-attribution.attributionAnswer',
			defaultMessage: '<bold>Answer</bold> verified across {trigger}',
			description:
				'SAIN variant: full attribution sentence shown in the answer card heading. <bold> wraps the word "Answer" which is rendered in bold. {trigger} is a clickable link reading "high confidence knowledge".',
		},
		triggerLabel: {
			id: 'rovo-platform-ui-components.authoritative-answer-attribution.triggerLabel',
			defaultMessage: 'high confidence knowledge',
			description:
				'Clickable link text within the attribution line that opens the combined sources and contributors panel.',
		},
		panelHeading: {
			id: 'rovo-platform-ui-components.authoritative-answer-attribution.panelHeading',
			defaultMessage: 'High confidence knowledge',
			description: 'Heading of the combined sources and contributors panel.',
		},
		closePanel: {
			id: 'rovo-platform-ui-components.authoritative-answer-attribution.closePanel',
			defaultMessage: 'Close',
			description: 'Accessible label for the button that dismisses the attribution detail panel.',
		},
		viewExpert: {
			id: 'rovo-platform-ui-components.authoritative-answer-attribution.viewExpert',
			defaultMessage: 'View {name}',
			description:
				'Accessible label for the button that navigates to an expert contributor profile. {name} is the expert name.',
		},
	});

export default messages;
